import React from 'react';
import { mockData } from '../utils/mock';
import { useLanguage } from '../context/LanguageContext';
import { Reveal, Eyebrow } from './decor';

const Pillars = () => {
  const { t, language } = useLanguage();
  const { pillars } = mockData;

  const loc = (v) => (typeof v === 'object' && v !== null ? v[language] || v.es : v);

  return (
    <section
      id="pillars"
      style={{ background: 'radial-gradient(ellipse 70% 50% at 50% -8%, rgba(245,242,234,0.06), transparent 62%), #141414', padding: '100px 0' }}
      data-testid="pillars-section"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-[60px]">
        <Reveal>
          <div className="text-center flex flex-col items-center">
            <Eyebrow centered>{t('sections.pillarsEyebrow')}</Eyebrow>
            <h2
              className="font-display mt-5"
              style={{ fontSize: 'clamp(34px, 5vw, 52px)', fontWeight: 700, color: '#F5F5F0' }}
            >
              {t('sections.pillarsTitle')}
            </h2>
            <p
              className="font-body mt-4"
              style={{ fontSize: '15px', fontWeight: 300, color: '#C2C1B6', maxWidth: '560px', lineHeight: 1.8 }}
            >
              {t('sections.pillarsSubtitle')}
            </p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 mt-16" style={{ gap: '2px' }}>
          {pillars.map((p, i) => (
            <Reveal key={p.number} delay={0.1 * i} className="group">
              <div
                className="relative overflow-hidden"
                style={{ height: '520px' }}
                data-testid={`pillar-card-${i}`}
              >
                <img
                  src={p.image}
                  alt={loc(p.name)}
                  className="absolute inset-0 w-full h-full object-cover transition-all duration-500 group-hover:scale-[1.06]"
                  style={{ filter: 'brightness(0.45)' }}
                  onMouseEnter={(e) => (e.currentTarget.style.filter = 'brightness(0.55)')}
                  onMouseLeave={(e) => (e.currentTarget.style.filter = 'brightness(0.45)')}
                />
                <div
                  className="absolute inset-0"
                  style={{ background: 'linear-gradient(0deg, #0A0A0A 0%, rgba(10,10,10,0.4) 60%, transparent 100%)' }}
                />

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-10">
                  <div
                    className="font-bebas"
                    style={{ fontSize: '72px', lineHeight: 0.9, color: '#C9A84C', opacity: 0.18 }}
                  >
                    {p.number}
                  </div>
                  <div className="flex items-center mt-2" style={{ gap: '10px' }}>
                    <span style={{ display: 'block', width: '24px', height: '1px', background: '#C9A84C' }} />
                    <span
                      className="font-body uppercase"
                      style={{ fontSize: '10px', letterSpacing: '2.5px', color: '#C9A84C' }}
                    >
                      {loc(p.tag)}
                    </span>
                  </div>
                  <h3 className="font-display mt-2" style={{ fontSize: '28px', fontWeight: 700, color: '#F5F5F0' }}>
                    {loc(p.name)}
                  </h3>
                  <p
                    className="font-body mt-3"
                    style={{ fontSize: '13px', fontWeight: 300, color: '#C2C1B6', lineHeight: 1.7 }}
                  >
                    {loc(p.description)}
                  </p>
                </div>

                {/* Bottom expanding gold line */}
                <span
                  className="absolute bottom-0 left-0"
                  style={{ height: '3px', width: '0%', background: '#C9A84C', transition: 'width 0.4s ease' }}
                  data-pillar-line
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <style>{`
        #pillars .group:hover [data-pillar-line] { width: 100%; }
      `}</style>
    </section>
  );
};

export default Pillars;
